export const RUBBER_TECHMAP_OPERATION_CLOSED_STATUSES = ['released', 'canceled'];
export const RUBBER_TECHMAP_OPERATION_ISSUE_DETAILS_STATUSES = ['accepted_at_sgd', 'partially_issued'];
